import { ISelectValues } from "../../../component/ISelectValues";

const BLUE = "secondary.transparent";
const PINK = "accent.transparent";
const GREEN = "success.transparent";
const RED = "error.transparent";

export const ID_FILTER_REPORT_NAME = "reportName";
export const ID_FILTER_STATUS = "status";
export const ID_FILTER_CREATION_DATE_FROM = "creationDateFrom";
export const ID_FILTER_CREATION_DATE_TO = "creationDateTo";
export const ID_FILTER_PAYMENT_DATE_FROM = "paymentDateFrom";
export const ID_FILTER_PAYMENT_DATE_TO = "paymentDateTo";
export const ID_FILTER_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_DEALERS = 'dealers'

export const NETWORK_CODE: ISelectValues[] = [
    {
        value: "06",
        label: "types.networkcode.PAN"
    },
    {
        value: "95",
        label: "types.networkcode.CUSTOMER_PAN_ALIAS"
    },
    {
        value: "98",
        label: "types.networkcode.PAN_ALIAS"
    }
];

export const TRANSACTION_STATUSES: ISelectValues[] = [
    {
        value: "READY",
        label: "types.statuses.READY",
        color: BLUE,
    },
    {
        value: "PROCESSING",
        label: "types.statuses.PROCESSING",
        color: PINK,
    },
    {
        value: "PROCESSED",
        label: "types.statuses.PROCESSED",
        color: GREEN,
    },
    {
        value: "ERROR",
        label: "types.statuses.ERROR",
        color: RED,
    }
];

export const getSummaryFields = () => {
    return [
      "READY",
      "PROCESSING",
      "PROCESSED",
      "ERROR"
    ];
  }


export const convertTypology = (type: ISelectValues[], value: string) => {
    const item = type.find((item) => item.value === value);
    return item ? item.label : value;
}

export const handleDownload = (reportName: string, base64String: string) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    console.log(url)
    a.href = url;
    a.download = reportName + '.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

export const reportDefaultValues = {
    [ID_FILTER_REPORT_NAME]: "",
    [ID_FILTER_STATUS]: [],
    [ID_FILTER_CREATION_DATE_FROM]: null,
    [ID_FILTER_CREATION_DATE_TO]: null,
    [ID_FILTER_PAYMENT_DATE_FROM]: null,
    [ID_FILTER_PAYMENT_DATE_TO]: null
};
